import api from "./api";

// Constants for API endpoints
const API_ROUTES = {
  CSRF: "sanctum/csrf-cookie",
  AUTH: {
    LOGIN: "api/login",
    VALIDATE: "api/checkotp",
    LOGOUT: "api/logout",
  },
};

// Generic API call creators
const createGetRequest = (endpoint) => () => api.get(endpoint);
const createPostRequest = (endpoint) => (data) => api.post(endpoint, data);

/**
 * Authentication related API endpoints
 */

// CSRF token
export const csrfCookies = createGetRequest(API_ROUTES.CSRF);

// Login request
export const loginUserApi = (phone, credentials) =>
  createPostRequest(API_ROUTES.AUTH.LOGIN)({
    phone,
    credentials,
  });

// OTP validation
export const checkValidationApi = (code, tokenApi, phoneNumber) =>
  createPostRequest(API_ROUTES.AUTH.VALIDATE)({
    code,
    token: tokenApi,
    phone: phoneNumber,
  });

// Logout request
export const SendLogoutRequestApi = createGetRequest(API_ROUTES.AUTH.LOGOUT);
